import React from 'react';
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Checkbox,
  InputGroup,
} from 'react-bootstrap';
import { bulletStringify } from '../../utils/utility';
import PaginateSelect from './PaginateSelect';

export default class FieldGroup extends React.Component {
  constructor(props) {
    super(props);

    // Set default value
    let value = props.value;
    if (
      props.componentClass !== PaginateSelect.TYPE_NAME &&
      props.value !== undefined &&
      props.value !== null
    ) {
      value = String(props.value);
    }
    // End set default value

    this.state = {
      value,
      isValid: false,
      isDirty: this.props.defaultDirty,
    };
  }

  clearInputData() {
    this.setState({
      value: '',
      isValid: false,
      isDirty: false,
    });
  }

  getFieldState() {
    return {
      value: this.state.value,
      isValid: this.state.isValid,
      isDirty: this.state.isDirty,
    };
  }

  validateField(value) {
    return this.props.validators.every(validator => validator(value));
  }

  onChangeHandler(event) {
    const value = event.target.value;
    const { onChange } = this.props;
    const isValid = this.validateField(value);
    event.persist();
    this.setState(
      {
        isValid: isValid,
        isDirty: true,
        value: value,
      },
      () => {
        if (onChange) {
          onChange(event);
        }
      });
  }

  getValidateState() {
    const { isDirty, isValid } = this.state;
    const { validators } = this.props;
    if (!isDirty || validators.length === 0) {
      return null;
    }

    return isValid ? 'success' : 'error';
  }

  componentWillReceiveProps(nextProps) {
    const { errorMessage } = nextProps;
    this.setState({
      isDirty: this.state.isDirty || !!errorMessage,
    });

    if (!this.state.value && this.props.componentClass === 'select' && nextProps.children.length >= 1) {
      this.setState({ value: nextProps.children[0].props.value });
    }

    if (this.props.alwaysUpdate) {
      this.setState({
        value: nextProps.value,
        isDirty: true,
        isValid: this.validateField(nextProps.value),
      });
    }
  }

  componentDidMount() {
    const isValid = this.validateField(this.state.value);
    this.setState({ isValid }, () => {
      if (this.props.onValid) {
        this.props.onValid(this.state.isValid);
      }
    });
  }

  render() {
    const { id, label, help, errorMessage, onValid, defaultDirty, alwaysUpdate, addonMsg, ...props } = this.props;
    const errorMessageString = Array.isArray(errorMessage) ? bulletStringify(errorMessage) : errorMessage;
    const validationState = this.getValidateState();

    return (
      <FormGroup
        controlId={id}
        validationState={validationState}
      >
        <ControlLabel>{label}</ControlLabel>{' '}
        {addonMsg ? this.withAddon(this.getFormControl(props), addonMsg) : this.getFormControl(props)}
        <FormControl.Feedback />
        {help && <HelpBlock>{help}</HelpBlock>}
        {errorMessage && <div className="error-list alert alert-danger">{errorMessageString}</div>}
      </FormGroup>
    );
  }

  withAddon(children, message) {
    return (
      <InputGroup>
        {children}
        <InputGroup.Addon>{message}</InputGroup.Addon>
      </InputGroup>
    );
  }

  getFormControl(props) {
    // Return custom paginate select instead of form control
    if (props.componentClass === PaginateSelect.TYPE_NAME) {
      return (
        <PaginateSelect
          {...props}
          onChange={selectedOption => this.onChangeHandler({ target: { value: selectedOption && selectedOption.value }, persist: () => null })}
        />
      );
    } else if (props.type === 'checkbox') {
      return (
        <Checkbox
          {...props}
          onChange={event => this.onChangeHandler({ target: { value: event.target.checked }, persist: () => null })}
        />
      );
    }
    const { onValueChange, ...pprops } = props;
    return (
      <FormControl
        {...pprops}
        value={this.state.value}
        onChange={event => this.onChangeHandler(event)}
      >
        {props.children}
      </FormControl>
    );
  }
}

FieldGroup.defaultProps = {
  validators: [],
  defaultDirty: false,
  alwaysUpdate: false,
};



// WEBPACK FOOTER //
// ./src/components/field_group/FieldGroup.js